import React from 'react';
import { Button } from './ui/button';
import { MdAddCircle } from 'react-icons/md';
import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { ButtonTooltip, TooltipProvider } from './ui/tooltip';

interface AddItemButtonProps {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  label: string;
  loadingLabel?: string;
  icon?: ReactNode;
  tooltip?: string;
}

export const AddItemButton: React.FC<AddItemButtonProps> = ({
  onClick,
  disabled = false,
  loading = false,
  label,
  loadingLabel,
  icon,
  tooltip,
}) => {
  const displayIcon = icon ?? (
    <MdAddCircle className="transition-transform duration-500 ease-in-out group-hover/add-item-button:rotate-[360deg]" />
  );
  const displayText = loading && loadingLabel ? loadingLabel : label;
  const isDisabled = disabled || loading;

  const button = (
    <Button
      onClick={onClick}
      disabled={isDisabled}
      size="sm"
      variant="inverse"
      className={cn(
        'h-auto min-h-8 max-w-full whitespace-normal',
        !icon && 'group/add-item-button',
      )}
    >
      {displayIcon}
      {displayText}
    </Button>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <TooltipProvider>
      <ButtonTooltip tooltip={tooltip}>{button}</ButtonTooltip>
    </TooltipProvider>
  );
};
